import React, { useState, useEffect } from 'react';
import './AnnouncementModal.css';
import { announcementStorage } from '../../utils/storage';
import { FaBullhorn, FaTimes, FaExclamationTriangle, FaCalendarAlt, FaUser } from 'react-icons/fa';

const AnnouncementModal = () => {
  const [announcements, setAnnouncements] = useState([
    {
      id: 1,
      title: 'Welcome to Alasar Academy',
      content: 'This is a test announcement to verify the modal is working correctly. You can manage announcements from the admin dashboard.',
      priority: 'high',
      date: new Date().toISOString().split('T')[0],
      author: 'Admin'
    }
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadAnnouncements = () => {
      try {
        const storedAnnouncements = announcementStorage.getAllAnnouncements();
        console.log('Loaded announcements:', storedAnnouncements);
        
        if (storedAnnouncements.length > 0) {
          setAnnouncements(storedAnnouncements);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error loading announcements:', error);
        setLoading(false);
      }
    };

    setTimeout(loadAnnouncements, 500);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % announcements.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + announcements.length) % announcements.length);
  };

  // Debug logging
  console.log('AnnouncementModal state:', { loading, isVisible, announcementsLength: announcements.length });

  if (loading) {
    return (
      <div className="announcement-modal-overlay">
        <div className="announcement-modal">
          <div className="modal-content">
            <p>Loading announcements...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!isVisible || announcements.length === 0) {
    console.log('Modal not visible or no announcements');
    return null;
  }

  const currentAnnouncement = announcements[currentIndex];

  return (
    <div className="announcement-modal-overlay">
      <div className="announcement-modal">
        <div className="modal-header">
          <div className="header-left">
            <FaBullhorn className="announcement-icon" />
            <h3>Important Announcement</h3>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-content">
          <div className="announcement-priority">
            <FaExclamationTriangle className="priority-icon high" />
            <span className="priority-text">HIGH PRIORITY</span>
          </div>

          <h2 className="announcement-title">
            {currentAnnouncement.title}
          </h2>

          <p className="announcement-content">
            {currentAnnouncement.content}
          </p>

          <div className="announcement-meta">
            <span className="meta-item">
              <FaCalendarAlt />
              {new Date(currentAnnouncement.date).toLocaleDateString()}
            </span>
            <span className="meta-item">
              <FaUser />
              {currentAnnouncement.author}
            </span>
          </div>
        </div>

        {announcements.length > 1 && (
          <div className="modal-navigation">
            <button 
              className="nav-btn prev-btn" 
              onClick={handlePrevious}
              disabled={announcements.length <= 1}
            >
              Previous
            </button>
            <div className="nav-indicators">
              {announcements.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
            <button 
              className="nav-btn next-btn" 
              onClick={handleNext}
              disabled={announcements.length <= 1}
            >
              Next
            </button>
          </div>
        )}

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;